import React, { useState, useEffect } from "react";
import axios from "axios";
import SidebarEtd from '../../../shared/components/SidebarEtd';
import HeaderEtd from '../../../shared/components/HeaderEtd';
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { FaEdit } from "react-icons/fa";
import {
  FaUser,
  FaUsers,
  FaPaperPlane,
  FaFileExcel,
  FaFolderOpen,
} from "react-icons/fa";
import ApplicantInfo from "./Applicant";
import PurposeInfo from "./Purpose";
import AttachmentsInfo from "./Documents";
import DecissionComponent from "./Action";
import ParentsInfo from "./Parents";
import { useLocation, useNavigate } from "react-router-dom";
import ContactPeople from "./ContactPeople";
import SponsorInfo from "./Sponsors";
import PaymentsInfo from "./PaymentsInfo";
import ViewHistoryComponent from "./viewHistory";
import { getSearchInfo } from '../../../shared/utils/storage';

const SearchedViewDetails = () => {
  const [application, setApplication] = useState();
  const [pageFrom, setPageFrom] = useState();
  const location = useLocation();
  const navigate = useNavigate();

  const applicationID = application?.ApplicationStatus[0]?.ApplicationID;

  useEffect(() => {
    const searchedData = getSearchInfo();
    if (searchedData) {
      setApplication(searchedData?.data);
      setPageFrom(searchedData?.pageFrom);
    }
  }, []);
  const back = () => {
    switch (pageFrom) {
      case "Report":
        navigate("/reports");
        break;
      case "Enquiry":
        navigate("/enquiry");
        break;
    }
  };

  const styles = {
    h4: {
      color: "#850505",
      textTransform: "uppercase",
    },
  };

  return (
    <>
      <HeaderEtd />
      <body className="">
        <div className="wrapper">
          <SidebarEtd />
          <div className="main-panel">
            <div className="content4">
              <br />
              <div className="container-fluid" style={{ marginTop: "20px" }}>
                <div className="row">
                  {/*-----------------------------------------*/}
                  <div className="col-md-12">
                    <div className="card2">
                      <div className="card-body">
                        <div className="row">
                          <div
                            className="collapse barNav-collapse barNav-1 col-md-10"
                            style={{ marginTop: "0px" }}
                          >
                            Application No.:&nbsp;
                            <text style={styles.h4}> {applicationID}</text>{" "}
                            &nbsp;&nbsp;&nbsp;
                          </div>

                          <div className="col-md-2" style={{ marginTop: "0px" }}>
                            <button
                              className="btn btn-primary"
                              onClick={back}
                              name="Action"
                              style={{ height: "30px", padding: "5px" }}
                            >
                              <b style={{ fontSize: "13px" }}>Back</b>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*-----------------------------------------*/}
                  <div className="col-md-12">
                    <div className="card2">
                      <div
                        className="card-body"
                        style={{ height: "32rem", overflowY: "scroll" }}
                      >
                        <Tabs defaultIndex={0}>
                          <TabList>
                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaUser />
                                &nbsp; Applicant
                              </b>
                              &nbsp;
                            </Tab>

                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaUsers />
                                &nbsp; Parents
                              </b>
                              &nbsp;
                            </Tab>
                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaUsers />
                                &nbsp; Sponsor
                              </b>
                              &nbsp;
                            </Tab>

                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaUsers />
                                &nbsp; Emergency
                              </b>
                              &nbsp;
                            </Tab>
                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaPaperPlane />
                                &nbsp; Purpose
                              </b>
                              &nbsp;
                            </Tab>
                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaUsers />
                                &nbsp; Payments
                              </b>
                              &nbsp;
                            </Tab>

                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <FaFolderOpen />
                                &nbsp; Documents
                              </b>
                              &nbsp;
                            </Tab>
                            {/* {isLocked && getLoginInfo()?.user?.Username === lockedBy && */}
                            <Tab>
                              &nbsp;
                              <b style={{ fontSize: "17px" }}>
                                <i className="fa fa-tasks" aria-hidden="true"></i>
                                &nbsp; History
                              </b>
                              &nbsp;
                            </Tab>
                            {/* } */}
                          </TabList>
                          <TabPanel>
                            <br />
                            <ApplicantInfo />
                          </TabPanel>
                          <TabPanel>
                            <br />
                            <ParentsInfo />
                          </TabPanel>
                          <TabPanel>
                            <br />
                            <SponsorInfo />
                          </TabPanel>

                          <TabPanel>
                            <br />
                            <ContactPeople />
                          </TabPanel>

                          <TabPanel>
                            <br />
                            <PurposeInfo />
                          </TabPanel>
                          <TabPanel>
                            <br />
                            <PaymentsInfo />
                          </TabPanel>
                          {/* <TabPanel>
                            <br />
                            <PreviousEtd />
                          </TabPanel> */}
                          <TabPanel>
                            <br />
                            <AttachmentsInfo />
                          </TabPanel>
                          {/* {isLocked && getLoginInfo()?.user?.Username === lockedBy && */}
                          <TabPanel>
                            <br />
                            <ViewHistoryComponent />
                          </TabPanel>
                          {/* } */}
                        </Tabs>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
};

export default SearchedViewDetails;
